import { createContext } from 'react';
import { colors } from '../tokens/colors';

export type Theme = 'light' | 'dark' | 'system';

export interface ThemeContextType {
  theme: Theme;
  isDarkMode: boolean;
  setTheme: (theme: Theme) => void;
  toggleTheme: () => void;
  colors: typeof colors | Record<string, unknown>;
}

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined);
